// Dependencies
import radium from 'radium';

// Styles
import './AddressData.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import countryEnum from "../../../lib/country-enum.js";

function AddressData(props) {

	const salutations = {
		MR: 'Herr',
		MS: 'Frau',
		COMPANY: 'Firma',
	};

	const address = props.address
	const addressHeadline = props.addressHeadline
	return (
		<div className="address">
			{addressHeadline &&
				<h2 className="address-label">
					{addressHeadline}
				</h2>
			}
			<div>
				{salutations[address.salutation]} {address.firstname} {address.lastname}
			</div>
			<div>{address.street} {address.houseNumber}</div>
			<div>{address.postalCode} {address.city}</div>
			<div>{countryEnum[address.countryCode]}</div>
			<div className="contact-data">
				<FontAwesomeIcon
					icon="phone"
					className="address-icon"
				/> {address.phoneNumber}</div>
			<div>
				<FontAwesomeIcon
					icon="envelope"
					className="address-icon"
				/>{address.email}</div>
		</div>
	);
}

export default radium(AddressData);
